import { z } from "zod";
/**
 * The tenant itself.
 *
 * There was no way to rename one. A workspace was named at sign-up from
 * whatever the first account typed and then kept that name forever, which is
 * fine until the name is "Demo Workspace" and the company is not a demo.
 */
export const workspaceSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
});
/**
 * Renaming it.
 *
 * The name is a label and nothing is keyed on it — no metric, no capture, no
 * join — so unlike a *brand* rename this changes what a person reads and
 * nothing about what anything measures.
 */
export const renameWorkspaceSchema = z.object({
    name: z.string().trim().min(1).max(120),
});
/**
 * A new workspace, made only when someone asks for one (plans/google-auth-and-invites.md,
 * D6). Its maker is its owner.
 */
export const createWorkspaceSchema = renameWorkspaceSchema;
//# sourceMappingURL=workspaces.js.map